<template>
    <div class="monitoring-kuli-modal" role="dialog" aria-modal="true" aria-labelledby="monitoring-kuli-detail-title" @click.self="close">
        <section class="monitoring-kuli-modal__panel">
            <header class="monitoring-kuli-modal__header">
                <h2 id="monitoring-kuli-detail-title">Detail Kuli</h2>
                <button class="monitoring-kuli-modal__close" type="button" aria-label="Tutup detail kuli" @click="close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </header>

            <div class="monitoring-kuli-modal__body">
                <p v-if="loading" class="monitoring-kuli-modal__state">Memuat detail kuli...</p>
                <p v-else-if="error" class="monitoring-kuli-modal__state monitoring-kuli-modal__state--error">{{ error }}</p>

                <template v-else-if="data">
                    <div class="monitoring-kuli-modal__name">
                        <span>Nama Kuli</span>
                        <strong>{{ data.nama_kuli }}</strong>
                    </div>

                    <div class="monitoring-kuli-modal__stats">
                        <div v-for="stat in stats" :key="stat.key" class="monitoring-kuli-modal__stat">
                            <span>{{ stat.label }}</span>
                            <strong>{{ valueOf(stat.key) }}</strong>
                        </div>
                    </div>

                    <div class="monitoring-kuli-modal__to-header">
                        <h3>List TO ({{ data.jumlah_to }})</h3>
                    </div>
                    <div class="monitoring-kuli-modal__to-list">
                        <p v-if="!data.to_list.length" class="monitoring-kuli-modal__empty">Tidak ada TO.</p>
                        <div v-for="(to, index) in data.to_list" :key="`${to.no_to}-${index}`" class="monitoring-kuli-modal__to-item">
                            {{ to.no_to }}
                        </div>
                    </div>
                </template>
            </div>

            <footer class="monitoring-kuli-modal__footer">
                <button
                    class="monitoring-kuli-button monitoring-kuli-button--primary"
                    type="button"
                    :disabled="loading || !data || exporting"
                    @click="$emit('export')"
                >
                    {{ exporting ? 'Downloading...' : 'Export Data' }}
                </button>
            </footer>
        </section>
    </div>
</template>

<script>
export default {
    name: 'MonitoringKuliDetailModal',
    props: {
        data: {
            type: Object,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ''
        },
        exporting: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            stats: [
                { key: 'jumlah_to', label: 'Jumlah TO' },
                { key: 'jumlah_koli', label: 'Jumlah Koli' },
                { key: 'jumlah_dus_oli', label: 'Jumlah Dus Oli' },
                { key: 'jumlah_dus_part', label: 'Jumlah Dus Part' },
                { key: 'jumlah_dus_ban', label: 'Jumlah Dus Ban' },
                { key: 'jumlah_dus_bat', label: 'Jumlah Dus Bat' }
            ]
        }
    },
    methods: {
        valueOf(key) {
            return this.data && this.data[key] !== undefined && this.data[key] !== null
                ? this.data[key]
                : '-'
        },
        close() {
            this.$emit('close')
        }
    }
}
</script>

<style scoped>
.monitoring-kuli-modal {
    align-items: center;
    background: rgba(52, 52, 52, .28);
    display: flex;
    justify-content: center;
    inset: 0;
    padding: 20px;
    position: fixed;
    z-index: 2000;
}

.monitoring-kuli-modal__panel {
    background: #FFFFFF;
    border-radius: 12px;
    box-shadow: 0 10px 28px rgba(0, 0, 0, .16);
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 40px);
    overflow: hidden;
    width: 480px;
}

.monitoring-kuli-modal__header {
    align-items: center;
    display: flex;
    flex: 0 0 auto;
    justify-content: space-between;
    padding: 24px 24px 12px;
}

.monitoring-kuli-modal__header h2 {
    color: #343434;
    font: normal normal 600 18px/27px Poppins, sans-serif;
    margin: 0;
}

.monitoring-kuli-modal__close {
    background: transparent;
    border: 0;
    color: #343434;
    cursor: pointer;
    font: normal normal 300 32px/24px Arial, sans-serif;
    height: 28px;
    padding: 0;
    width: 28px;
}

.monitoring-kuli-modal__body {
    min-height: 0;
    overflow: auto;
    padding: 0 24px;
}

.monitoring-kuli-modal__name {
    display: flex;
    flex-direction: column;
    gap: 3px;
    margin: 8px 0 14px;
}

.monitoring-kuli-modal__name span,
.monitoring-kuli-modal__stat span {
    color: #B9B9B9;
    font: normal normal normal 12px/18px Poppins, sans-serif;
}

.monitoring-kuli-modal__name strong {
    color: #F36F21;
    font: normal normal 600 18px/27px Poppins, sans-serif;
}

.monitoring-kuli-modal__stats {
    display: grid;
    gap: 8px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.monitoring-kuli-modal__stat {
    background: #F8F8F8;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 1px;
    min-height: 64px;
    padding: 8px 12px;
}

.monitoring-kuli-modal__stat strong {
    color: #343434;
    font: normal normal 600 16px/24px Poppins, sans-serif;
}

.monitoring-kuli-modal__to-header {
    padding: 20px 0 12px;
}

.monitoring-kuli-modal__to-header h3 {
    color: #343434;
    font: normal normal 600 14px/21px Poppins, sans-serif;
    margin: 0;
}

.monitoring-kuli-modal__to-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 270px;
    overflow: auto;
    padding-bottom: 4px;
}

.monitoring-kuli-modal__to-item {
    border: 1px solid #E5E5E5;
    border-radius: 6px;
    color: #343434;
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    font: normal normal normal 14px/20px Poppins, sans-serif;
    min-height: 40px;
    overflow-wrap: anywhere;
    padding: 9px 12px;
}

.monitoring-kuli-modal__empty,
.monitoring-kuli-modal__state {
    color: #888888;
    font: normal normal normal 14px/21px Poppins, sans-serif;
    margin: 24px 0;
    text-align: center;
}

.monitoring-kuli-modal__state--error {
    color: #B3261E;
}

.monitoring-kuli-modal__footer {
    display: flex;
    flex: 0 0 auto;
    justify-content: flex-end;
    padding: 14px 24px 24px;
}

.monitoring-kuli-button {
    border: 0;
    border-radius: 8px;
    cursor: pointer;
    font: normal normal 600 14px/21px Poppins, sans-serif;
    min-height: 36px;
    padding: 7px 24px;
}

.monitoring-kuli-button--primary {
    background: #1B698E;
    color: #FFFFFF;
    min-width: 131px;
}

.monitoring-kuli-button:disabled {
    cursor: not-allowed;
    opacity: .65;
}

@media (max-width: 576px) {
    .monitoring-kuli-modal {
        padding: 12px;
    }

    .monitoring-kuli-modal__panel {
        width: 100%;
    }
}
</style>
